import { useState } from 'react';
import ActivationLinkCard from './ActivationLinkCard';
import { Modal } from 'react-bootstrap';
import { Button, ModalCloseCrossIcon } from 'edrolo-style-guide';
import style from './StudentPendingActivationModal.scss';
import pluralize from 'pluralize';
/* eslint-disable react/prop-types */ // TODO: add props

const StudentPendingActivationModal = ({
  studentNamesList,
  activationLink,
}) => {
  const [show, setShow] = useState(false);

  if (!studentNamesList.length || !activationLink) {
    return null;
  }

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);

  return (
    <div className={style.modalContainer}>
      <a role="button" className={style.warning} onClick={handleShow}>
        {`${pluralize('student', studentNamesList.length, true)} yet to log in`}
      </a>
      <Modal show={show} onHide={handleClose} className={style.modal}>
        <Modal.Header className={style.header}>
          <span className={style.crossIcon} onClick={handleClose}>
            <ModalCloseCrossIcon />
          </span>
        </Modal.Header>

        <Modal.Body className={style.modalBody}>
          <p className={style.heading}>
            {`${pluralize(
              'student',
              studentNamesList.length,
              true
            )} yet to log in`}
          </p>
          <ul className={style.studentNamesList}>
            {studentNamesList.map((studentName, index) => {
              return <li key={index}>{studentName}</li>;
            })}
          </ul>
          <p className={style.prompt}>
            Prompt your students to start using Edrolo with the below link:
          </p>
          <div className={style.activationLinkCardContainer}>
            <ActivationLinkCard activationLink={activationLink} />
          </div>
        </Modal.Body>

        <Modal.Footer className={style.footer}>
          <Button disabled={false} onClick={handleClose} data-test="got-it">
            Got it
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StudentPendingActivationModal;
